import type { TOC } from '@ember/component/template-only';

export interface FeedbackWarningSignature {
  // The arguments accepted by the component
  Args: {
    header: string;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: HTMLDivElement;
}

<template>
  <div
    class="rounded-md bg-yellow-50 p-4 dark:bg-yellow-500/10 dark:outline dark:outline-yellow-500/15"
    ...attributes
  >
    <div class="flex">
      <div class="shrink-0">
        <svg
          viewBox="0 0 20 20"
          fill="currentColor"
          data-slot="icon"
          aria-hidden="true"
          class="size-5 text-yellow-400 dark:text-yellow-300"
        >
          <path
            d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
            clip-rule="evenodd"
            fill-rule="evenodd"
          />
        </svg>
      </div>
      <div class="ml-3">
        <h3
          class="text-sm font-medium text-yellow-800 dark:text-yellow-100"
        >{{@header}}</h3>
        <div class="mt-2 text-sm text-yellow-700 dark:text-yellow-100/80">
          {{yield}}
        </div>
      </div>
    </div>
  </div>
</template> satisfies TOC<FeedbackWarningSignature>;
